/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Droplets, Layers, Fan, Waves, Thermometer, Shield, Volume2 } from "lucide-react";

import ProductDetailPage, {
	type ProductDetailConfig,
} from "./ProductDetailPage";

const DRY_COOLERS: ProductDetailConfig = {
	i18nKey: "dryCoolers",
	path: "/products/dry-coolers",
	heroBackground: "/images/header/AIRCOOLEDHEATEXCHANGER.jpg",
	images: ["/images/finalProducts/DRY COOLER.png"],
	highlightKeys: ["waterSaving", "coilsAndFins", "fanAutomation"],
	highlightIcons: [Droplets, Layers, Fan],
	specKeys: ["coolingMedium", "operationalRange", "construction", "fanNoise"],
	specIcons: [Waves, Thermometer, Shield, Volume2],
	wordmark: "DRY",
	compliancePill: "Closed Circuit · Zero Water",
	captionEyebrow: "Water-Free Process Cooling",
	captionTitle: "Dry Cooler",
	specsFooterLabel: "Positron Engineering · Dry Cooler Series",
};

export default function DryCoolers() {
	return <ProductDetailPage config={DRY_COOLERS} />;
}
